import React, { useState } from 'react';
import './Useraccounts.css';
import EditUserModal from './EditUserModal'; 
import { update_adminsproviders,delete_adminsproviders } from '../../../services/AuthServices';
function Useraccounts({ userdata,onupdate }) {
  const [users, setUsers] = useState(userdata || []); // CHANGE THIS LINE
  const [editingUser, setEditingUser] = useState(null); // ADD THIS LINE
  const [showEditModal, setShowEditModal] = useState(false);

  console.log("userdata list", userdata, users);

  // Function to get provider type label
  const getProviderTypeLabel = (providerTypes) => {
    if (!providerTypes || providerTypes.length === 0) return 'No Type';
    return providerTypes[0]?.type || 'Unknown';
  };

  // Function to get color based on provider type
  const getTypeColor = (type) => {
    const typeLower = type?.toLowerCase() || '';
    if (typeLower.includes('admin')) return 'type-admin';
    if (typeLower.includes('priest')) return 'type-priest';
    if (typeLower.includes('manager')) return 'type-manager';
    if (typeLower.includes('support')) return 'type-support';
    return 'type-default';
  };

  // Function to format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  // Get initials from name
  const getInitials = (firstName, lastName) => {
    const first = firstName?.charAt(0).toUpperCase() || '';
    const last = lastName?.charAt(0).toUpperCase() || '';
    return first + last;
  };
// Function to handle edit button click
const handleEdit = (user) => {
  setEditingUser(user);
  setShowEditModal(true);
};

// Function to handle save after editing
const handleSave = async (updatedData) => {
  try {
    // Using the service function
    console.log("updatedData",updatedData.id,updatedData)
    const result = await update_adminsproviders({
      id: updatedData.id,
      data:updatedData,
    });

    // Update local state with the updated user
    const updatedUsers = users.map(user => 
      user.id === result.user.id ? result.user : user
    );
    setUsers(updatedUsers);
    
    // Notify parent component if callback provided
    if (onupdate) {
      onupdate(updatedUsers);
    }
    
    setShowEditModal(false);
    alert('User updated successfully!');
  } catch (error) {
    alert(`Error: ${error.message}`);
    console.error('Error updating user:', error);
  }
};

// Function to handle delete (soft delete)
const handleDelete = async (userId) => {
  if (!window.confirm('Are you sure you want to deactivate this user?')) {
    return;
  }

  try {
    // Using the service function
    const result = await delete_adminsproviders(userId);

    // Update local state - mark user as inactive
    const updatedUsers = users.map(user => 
      user.id === userId ? { ...user, isActive: false } : user
    );
    setUsers(updatedUsers);
    
    // Notify parent component if callback provided
    if (onupdate) {
      onupdate(updatedUsers);
    }
    
    alert('User deactivated successfully!');
  } catch (error) {
    alert(`Error: ${error.message}`);
    console.error('Error deactivating user:', error);
  }
};
  // Empty state
  if (users.length === 0) {
    return (
      <div className="user-accounts-container">
        <div className="empty-state">
          
          <h3>No Users Found</h3>
          <p>Create a new user to get started</p>
        </div>
      </div>
    );
  }

  // Count active users
  const activeUsers = users.filter(u => u.isActive).length;
  const inactiveUsers = users.filter(u => !u.isActive).length;

  return (
    <div className="user-accounts-container">
      {/* Header */}
         {showEditModal && (
      <EditUserModal 
        user={editingUser}
        onSave={handleSave}
        onClose={() => setShowEditModal(false)}
      />
    )}
      <div className="accounts-header">
        <div className="header-left">
          <h2>User Accounts ({users.length})</h2>
        </div>
        <div className="header-right">
          <span className="stats-badge active">
            
            {activeUsers} Active
          </span>
          <span className="stats-badge inactive">
            
            {inactiveUsers} Inactive
          </span>
        </div>
      </div>

      {/* Desktop View - Table */}
      <div className="desktop-view">
        <div className="table-container">
          <table className="users-table">
            <thead>
              <tr>
                <th>User</th>
                <th>Contact</th>
                <th>Email</th>
                <th>Type</th>
                <th>Status</th>
                <th>Joined</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id} className="user-row">
                  <td className="user-info">
                    <div className="user-avatar">
                      {getInitials(user.firstName, user.lastName)}
                    </div>
                    <div className="user-details">
                      <div className="user-name">
                        {user.firstName} {user.lastName}
                      </div>
                      <div className="user-id">ID: {user.id}</div>
                    </div>
                  </td>
                  <td className="contact-info">
                    <div className="contact-item">
                      
                      <span>{user.countryCode} {user.mobileNumber}</span>
                    </div>
                    {!user.isMobileVerified && (
                      <span className="verification-badge unverified">
                        Unverified
                      </span>
                    )}
                  </td>
                  <td className="email-info">
                    {user.emailId ? (
                      <>
                        <div className="contact-item">
                          
                          <span>{user.emailId}</span>
                        </div>
                        {!user.isEmailIdVerified && (
                          <span className="verification-badge unverified">
                            Unverified
                          </span>
                        )}
                      </>
                    ) : (
                      <span className="no-email">No email</span>
                    )}
                  </td>
                  <td>
                    <span className={`type-badge ${getTypeColor(getProviderTypeLabel(user.providerTypes))}`}>
                      
                      {getProviderTypeLabel(user.providerTypes)}
                    </span>
                  </td>
                  <td>
                    <span className={`status-badge ${user.isActive ? 'active' : 'inactive'}`}>
                      {user.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                  <td className="join-date">
                    {formatDate(user.createdAt)}
                  </td>
                  <td className="actions">
                    <button className="action-btn edit" title="Edit"     onClick={() => handleEdit(user)} >
                      Edit
                    </button>
                    <button className="action-btn delete" title="Delete"     onClick={() => handleDelete(user.id)}   >
                      {user.isActive ? 'Deactivate' : 'Deactivated'} 
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile View - Cards */}
      <div className="mobile-view">
        <div className="users-list">
          {users.map((user) => (
            <div key={user.id} className="user-card">
              <div className="card-header">
                <div className="user-avatar">
                  {getInitials(user.firstName, user.lastName)}
                </div>
                <div className="user-main-info">
                  <div className="user-name">
                    {user.firstName} {user.lastName}
                  </div>
                  <div className="user-id">ID: {user.id}</div>
                </div>
                <button className="more-btn">
                  
                </button>
              </div>
              
              <div className="card-body">
                <div className="info-row">
                  
                  <span className="info-label">Mobile:</span>
                  <span className="info-value">
                    {user.countryCode} {user.mobileNumber}
                  </span>
                  {!user.isMobileVerified && (
                    <span className="verification-badge unverified">Unverified</span>
                  )}
                </div>
                
                <div className="info-row">
                  
                  <span className="info-label">Email:</span>
                  <span className="info-value">
                    {user.emailId || 'Not provided'}
                  </span>
                  {user.emailId && !user.isEmailIdVerified && (
                    <span className="verification-badge unverified">Unverified</span>
                  )}
                </div>
                
                <div className="info-row">
                  
                  <span className="info-label">Type:</span>
                  <span className={`type-badge ${getTypeColor(getProviderTypeLabel(user.providerTypes))}`}>
                    {getProviderTypeLabel(user.providerTypes)}
                  </span>
                </div>
              </div>
              
              <div className="card-footer">
                <div className="footer-left">
                  <span className={`status-badge ${user.isActive ? 'active' : 'inactive'}`}>
                    {user.isActive ? 'Active' : 'Inactive'}
                  </span>
                  <span className="join-date">
                    Joined: {formatDate(user.createdAt)}
                  </span>
                </div>
                <div className="footer-right">
                  <button className="action-btn edit" onClick={() => handleEdit(user)}>Edit</button>
                  <button className="action-btn delete"
                  onClick={() => handleDelete(user.id)} 
                   >Delete</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="accounts-footer">
        <div className="footer-left">
          Showing {users.length} user{users.length !== 1 ? 's' : ''}
        </div>
        <div className="footer-right">
          Last updated: {new Date().toLocaleTimeString()}
        </div>
      </div>
    </div>
  );
}

export default Useraccounts;